import { Component } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { BaseComponent } from '../../base.component';
import {
  clearStorage,
  getAccountId,
  getToken,
} from '../../service/base.service';
import { DatePipe } from '@angular/common';
import { NavigationStart, Router } from '@angular/router';
import { Transferencia } from 'src/app/shared/model/transferencias/transferencia.model';
import { TransferenciaService } from 'src/app/shared/service/transferencias/transferencia.service';
import { environment } from 'src/environments/environment';
import { TableColumn } from 'src/app/shared/ui/table/table.component';

@Component({
  selector: 'cmp-minhas-transferencias',
  templateUrl: './minhas-transferencias.component.html',
  styleUrls: [
    './minhas-transferencias.component.scss',
    `../../../../themes/xpory/css/component/transferencias/minhas-transferencias.component.scss`,
    `../../../../themes/xpory-futebol/css/component/transferencias/minhas-transferencias.component.scss`,
    `../../../../themes/fcj-barter/css/component/transferencias/minhas-transferencias.component.scss`,
  ],
})
export class MinhasTransferenciasComponent extends BaseComponent {
  theme = environment.theme_name;
  isRealizada: boolean = true;
  transferencias: Transferencia[] = [];
  inicio: Date;
  fim: Date;
  dateShowInicio: boolean;
  dateShowFim: boolean;

  count: number = 0;
  offset: number;
  max: number;

  checked: boolean;

  tableColumns: TableColumn[] = [
    { label: 'Data', key: 'dateCreated' },
    { label: 'Valor', key: 'value' },
  ];

  constructor(
    public router: Router,
    private datePipe: DatePipe,
    private service: TransferenciaService,
    public toastController: ToastController,
    public loadingController: LoadingController
  ) {
    super(router, toastController, loadingController);
  }

  ngOnInit(): void {
    this.offset = 0;
    this.max = 12;

    this.carregarTransferencias();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.checked = false;
      }
    });
  }

  ngAfterViewChecked(): void {
    if (!this.checked) {
      this.carregarTransferencias();
      this.checked = true;
    }
  }

  carregarTransferencias() {
    this.openLoading('Carregando transferências...');
    this.offset = 0;
    this.max = 12;
    var token = getToken();
    var accountId = getAccountId();
    if (this.inicio && this.fim) {
      var inicio = this.datePipe.transform(this.inicio, 'MM/dd/yyyy')!;
      var fim = this.datePipe.transform(this.fim, 'MM/dd/yyyy')!;

      this.service
        .listarData(
          token,
          accountId,
          this.isRealizada ? 's' : 'r',
          inicio,
          fim,
          this.offset,
          this.max
        )
        .then((resultado) => {
          this.count = resultado.listFullSize;
          this.transferencias = resultado.transfers.map((transferencia) => ({
            ...transferencia,
            dateCreated: this.datePipe.transform(
              transferencia.dateCreated,
              'dd/MM/yyyy'
            )!,
            value: this.formatarValorEmX(transferencia.value),
          }));
          this.closeLoading();
        })
        .catch((ex) => {});
    } else {
      this.service
        .listar(
          token,
          accountId,
          this.isRealizada ? 's' : 'r',
          this.offset,
          this.max
        )
        .then((resultado) => {
          this.count = resultado.listFullSize;
          this.transferencias = resultado.transfers.map((transferencia) => ({
            ...transferencia,
            dateCreated: this.datePipe.transform(
              transferencia.dateCreated,
              'dd/MM/yyyy'
            )!,
            value: this.formatarValorEmX(transferencia.value),
          }));
          this.closeLoading();
        })
        .catch((ex) => {});
    }
  }

  loadData(event) {
    this.offset += this.max;
    var token = getToken();
    var accountId = getAccountId();

    if (this.inicio && this.fim) {
      var inicio = this.datePipe.transform(this.inicio, 'MM/dd/yyyy')!;
      var fim = this.datePipe.transform(this.fim, 'MM/dd/yyyy')!;

      this.service
        .listarData(
          token,
          accountId,
          this.isRealizada ? 's' : 'r',
          inicio,
          fim,
          this.offset,
          this.max
        )
        .then((resultado) => {
          if (event.target) {
            event.target.complete();
          }

          if (resultado) {
            if (!resultado.msg) {
              var transferencias = resultado.transfers;
              this.transferencias = this.transferencias.concat(transferencias);
            }
          }
        });
    } else {
      this.service
        .listar(
          token,
          accountId,
          this.isRealizada ? 's' : 'r',
          this.offset,
          this.max
        )
        .then((resultado) => {
          if (event.target) {
            event.target.complete();
          }

          if (resultado) {
            if (!resultado.msg) {
              var transferencias = resultado.transfers;
              this.transferencias = this.transferencias.concat(transferencias);
            }
          }
        });
    }
  }

  onSelectInicio(inicio: Date) {
    this.inicio = inicio;
    this.carregarTransferencias();
  }

  onSelectFim(fim: Date) {
    this.fim = fim;
    this.carregarTransferencias();
  }
}
